<template>
  <v-card >
    <v-card-title dense class="py-2">
      <div>
        <h3>{{ title }}</h3>
        <crumbs :crumbs="crumbs" background="back" text="black" size="caption"/>
      </div>
    </v-card-title>

      <!-- Выбор локации в дереве -->
      <div style="max-height: 600px; overflow: auto" v-if="loc_select && step == 0">
        <v-treeview
          disable-resize-watcher="true"
          style="cursor: pointer"
          :items="getTree"
          :active.sync="loc_active"
          :open.sync="loc_opened"
          :load-children="loadChildren"
          loading-icon="autorenew"
          expand-icon="expand_more"
          active-class=""
          class="caption font-weight-medium font-condensend"
          activatable
          item-key="$id"
          return-object
        >
          <template v-slot:label="{ item, open, active }" :data-testid="$options.name + '__template__' + item.$id">
            <v-layout fill-height align-center class="treeLeaf" :style="active ? 'background-color: #D1D2D4' : 'background-color: #ffffff'" px-2>
              <svg-icon
                color="blackLine"
                :name="$checkItem(item)"
                width="34"
              />
              <span class="caption font-weight-medium font-condensend px-2">{{
                item.name
              }}</span>
            </v-layout>
          </template>
        </v-treeview>
      </div>
      <!-- Выбор стойки -->
      <v-list class="pa-0" v-if="!loc_select && step == 0" key="list0">
        <v-list-tile
          v-for="item in getTreeActive.children"
          v-if="item.cls == 'cabinet'"
          :key="item.$id"
          active-class='selected-item'
          :data-testid="$options.name + '__list-tile__' + item.$id"
          @click="selected = selected === item.$id ? '' : selected = item.$id"
          :class="['pl-0', item.$id === selected ? 'selected-item' : '']"
        >
          <v-list-tile-action>
            <svg-icon
              name="cabinet"
              :color="getTreenodeIconColor(item.$id)"
              width="20"
            />
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title v-text="item.name"></v-list-tile-title>
          </v-list-tile-content>

        </v-list-tile>
      </v-list>

      <!-- Выбор слота в стойке -->

      <v-flex shrink v-if="step == 1" :style="`min-width: ${getActiveCabinet.width * 0.4}px; min-height: 600px; overflow: auto; transform: scale(1);`"  class="px-3">

        <v-layout ma-0 pa-0 >

            <component
              is="cabinet-side"
              :mount="'side'"
              :selectedSlot="selectedSlot"
              :selectedSlots="selectedSlots"
              :selectedSlotsSide="selectedSlotsSide"
              :data="getActiveCabinet"
              @select="(payload) => selectUnits(payload)"
            />

        </v-layout>

      </v-flex>

      <!-- Выбор слота в устройстве -->
      <div v-if="getSelectedItem" class="choosing-slot">
        <!-- Переключатель сторон -->
        <v-btn-toggle :data-testid="$options.name + 'v-btn' + 'choose-unit'"         
        v-model="deviceSide" class="item-side">
          <v-btn flat small 
          :data-testid="$options.name + '__btn-toggle __' + 'front'"
          value="front">
            FRONT
          </v-btn>
          <v-btn flat small 
          :data-testid="$options.name + '__btn-toggle __' + 'rear'"
          value="rear">
            REAR
          </v-btn>
        </v-btn-toggle>
        <!-- Схема устройства -->
        <div class="device" :style="getStyleByDeviceSize">
          <div v-for="item in getActive.children.filter(c => c.cls == 'slot' && c.side == deviceSide)" :key="item.$id"
            :class="{
              'device-item': true,
              buzy_slot: item.children.length,
              compatible: item.compatible.includes(getSelectedItem.template),
              selected: item.$id == selectedItem,
              current: item.children.length && item.children[0].$id == getSelectedItem.$id
            }"
             :data-testid="$options.name + '__div__' + 'checkAndSelectSlot'"
            @click="checkAndSelectSlot(item)"
            :style="getStyleOfUnitBySize(item)"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <div v-on="on" :class="{'slot-name': true, vertical: item.orientation == 1}" >{{itemNameDependOnSize(item)}}</div>
              </template>
              <span>{{item.name}}</span>
            </v-tooltip>
          </div>
        </div>
        <div>Выбран слот "{{selectedItem ? getActive.children.find(e => e.$id == selectedItem)['name'] : '-'}}"</div>
      </div>

    <v-card-actions>
      <v-spacer></v-spacer>
      <!-- Выбор юнита для перемещения устройства в стойке -->
      <v-btn flat color="light-blue accent-4"
        v-if="isCabinet && !loc_select"
        :data-testid="$options.name + '__btn-card-actions__' + 'isCabinet && !loc_select choose'"
        @click="step = 1 - step; loc_select = false"
      >{{step == 1 ? $t('choose location') : $t('back to cabinet')}}</v-btn>
      <!-- Выбор юнита для перемещения устройства в стойке -->
      <v-btn flat color="green accent-4"
        v-if="!getSelectedItem && step == 0 && (!loc_select || selectedIsCabinet)"
        :data-testid="$options.name + '__btn-card-actions__' + '!getSelectedItem && step == 0 && (!loc_select || selectedIsCabinet) choose'"
        @click="chooseUnit"
        :disabled="!selected && !selectedSlots.length && !selectedIsCabinet"
      >{{$t('choose unit')}}</v-btn>
      <v-btn flat color="light-blue accent-4"
        v-if="!getSelectedItem && step != 0 && (!loc_select || selectedIsCabinet)"
        :data-testid="$options.name + '__btn-card-actions__' + '!getSelectedItem && step != 0 && (!loc_select || selectedIsCabinet) move'"
        @click="chooseUnit"
        :disabled="!selected && !selectedSlots.length && !selectedIsCabinet"
      >{{$t('replace')}}</v-btn>
      <!-- Назад в выбор локации -->
      <v-btn flat color="orange darken-4"
        v-if="isCabinet && loc_select && step == 1"
        :data-testid="$options.name + '__btn-card-actions__' + 'isCabinet && loc_select && step == 1 back'"
        @click="loc_active = []; step = 0"
      >{{$t('back')}}</v-btn>
      <!-- Назад в выбор стойки -->
      <v-btn flat color="orange darken-4"
        v-if="!isCabinet && !loc_select && step == 1"
        :data-testid="$options.name + '__btn-card-actions__' + 'isCabinet && loc_select && step == 1 back'"
        @click="step = 0; selected = ''"
        :disabled="!selected"
      >{{$t('back')}}</v-btn>
      <!-- Добавить корневым элементом (в physical) -->
      <v-btn flat color="orange darken-4"
        v-if="!loc_active.length"
        :data-testid="$options.name + '__btn-card-actions__' + 'moveToRoot'"
        @click="moveToRoot"
      >{{$t('move to root')}}</v-btn>
      <!-- Переместить устройство в юнит -->
      <v-btn flat color="orange darken-4"
        v-if="loc_select && loc_active[0] && loc_active[0].cls != 'cabinet'"
        :data-testid="$options.name + '__btn-card-actions__' + 'loc_select && loc_active[0] && loc_active[0].cls != replace'"
        @click="moveToLocation"
        :disabled="!loc_active.length || loc_active[0].cls == 'cabinet'"
      >{{$t('replace')}}</v-btn>
      <!-- Переместить модуль в слот -->
      <v-btn flat color="orange darken-4"
        v-if="getSelectedItem"
        :data-testid="$options.name + '__btn-card-actions__' + 'getSelectedItem'"
        @click="moveToSlot"
        :disabled="!selectedItem"
      >{{$t('replace')}}</v-btn>
      <!-- Отмена, закрытие окна -->
      <v-btn flat color="primary"
        :data-testid="$options.name + '__btn-card-actions__' + 'close'"
        @click="() => close()"
      >{{$t('cancel')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import Crumbs from '@/nms/components/partials/bread-crumbs.vue'
import CabinetSide from '@/nms/components/cabinet/cabinet-side.vue'
import { mapGetters } from 'vuex'
import { CCMDBObject } from '@entcor/ebridge'

// Типы
interface TreeNode {
  $id?: string
  id?: string
  name?: string
  cls?: string
  type?: string
  children?: TreeNode[]
  parents?: any[]
  [key: string]: any
}

interface ExceptionsMap {
  [key: string]: string[]
}

interface CurrentState {
  cabinet: TreeNode
}

interface AcceptState {
  status: boolean
  message: string
}

interface SlotItem {
  opened: boolean
  name: number
}

interface DeviceItem {
  $id?: string
  id?: string
  name?: string
  cls?: string
  template?: string
  height?: number
  width?: number
  depth?: number
  position?: number
  mount?: string
  [key: string]: any
}

interface CabinetItem {
  $id?: string
  cls?: string
  name?: string
  usize?: number
  depth?: number
  children?: DeviceItem[]
  [key: string]: any
}

interface ActiveDevice {
  $id?: string
  height?: number
  width?: number
  depth?: number
  [key: string]: any
}

interface ClosedUnit {
  position: number
  device: DeviceItem[]
}

interface ClosedUnitSet {
  [key: number]: boolean
}

interface UnitItem {
  position: number
  side: string
  closed: ClosedUnit[]
  cabinet: {
    obj: CabinetItem
    name?: string
    cls?: string
    id?: string
    usize?: number
  }
}

/**
 * Generate array [0..len-1]
 */
const range = (len: number): number[] => Array.from(Array(len).keys())

export default Vue.extend({
  name: 'DEVICE_REPLACE_CHOOSE',

  components: {
    svgIcon,
    Crumbs,
    CabinetSide
  },

  props: {
    menuVisible: {
      type: Boolean,
      default: false
    }
  },

  data(): {
    includes: string[]
    exceptions: ExceptionsMap
    crumbs: any[]
    headers: string[]
    loc_select: boolean
    loc_active: TreeNode[]
    loc_opened: TreeNode[]
    step: number
    deviceSize: number
    deviceSide: string
    selected: string
    selectedSlot: UnitItem | null
    selectedSlotsSide: string
    selectedSlots: number[]
    selectedItem: string
    slots: SlotItem[]
    deviceScale: number
    current: CurrentState
    accept: AcceptState
  } {
    return {
      includes: ['location', 'cabinet'],
      exceptions: {
        location: ['type'],
      },
      crumbs: [],
      headers: ['Выберите стойку', 'Выберите размещение: '],
      loc_select: true,
      loc_active: [],
      loc_opened: [],
      step: 0,
      deviceSize: 1,
      deviceSide: 'front',
      selected: '',
      selectedSlot: null,
      selectedSlotsSide: 'front',
      selectedSlots: [],
      selectedItem: '',
      slots: [],
      deviceScale: 0.55,
      current: {
        cabinet: {}
      },
      accept: {
        status: true,
        message: 'Ok'
      },
    }
  },

  computed: {
    getTree(): TreeNode[] {
      const filter = (arr: TreeNode[] | undefined, inc: string[], exc: ExceptionsMap): TreeNode[] => {
        return (arr || [])
          .map(n$ => {
            const n = new CCMDBObject({ ...n$ })
            if (!n.children?.length) {
              return n
            } else {
              n.children = filter(n.children, inc, exc)
              return n
            }
          })
          .filter((n): n is TreeNode => {
            if (n && n.cls && inc.includes(n.cls)) {
              if (Object.keys(exc).includes(n.cls)) {
                return !exc[n.cls].find(field => !n[field])
              }
              return true
            }
            return false
          })
      }
      const store = this.$store.state as any
      return filter(store.devices.tree, this.includes, this.exceptions)
    },

    title(): string {
      if (this.loc_select) {
        return 'Выберите локацию'
      } else if (this.getSelectedItem) {
        const end = this.deviceSize === 1 ? '' : (this.deviceSize < 5 ? 'а' : 'ов')
        const slotsCount = this.step === 0 ? '' : `${this.deviceSize} слот${end}`
        return `Выберите слот в устройстве: ${slotsCount}`
      } else {
        return `${this.headers[this.step]}`
      }
    },

    getTreeOpened(): TreeNode[] {
      const store = this.$store.state as any
      return store.devices.treeOpened
    },

    getActive(): ActiveDevice | null {
      const store = this.$store.state as any
      return store.devices.activeDevice
    },

    getStyleByDeviceSize(): { height: string; width: string } {
      const d = this.getActive
      if (!d) return { height: '0px', width: '0px' }
      return {
        height: `${(d.height! * this.deviceScale).toFixed(1)}px`,
        width: `${(d.width! * this.deviceScale).toFixed(1)}px`
      }
    },

    getSelectedItem(): any | null {
      const store = this.$store.state as any
      return store.devices.selectedItem
    },

    isCabinet(): boolean {
      const treeActive = this.getTreeActive
      return treeActive?.cls === 'cabinet' && this.getSelectedItem == null
    },

    selectedIsCabinet(): boolean {
      return this.loc_active.length && this.loc_active[0]?.cls === 'cabinet'
    },

    getActiveCabinet(): TreeNode {
      return this.current.cabinet
    },

    getCrumbs(): any[] {
      return this.crumbs
    },

    ...mapGetters(['getTreeActive']),
  },

  watch: {
    menuVisible(val: boolean): void {
      if (!val) {
        this.close()
        return
      }
      if (this.isCabinet) {
        this.setup()
      }
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(caller?: string): Promise<void> {
      if (!this.menuVisible) return
      
      this.crumbs = await this.$createCrumbs(this.getActive)
      const activeDevice = this.$store.state.devices.activeDevice as ActiveDevice | null
      this.deviceSize = activeDevice ? Math.ceil(activeDevice.height! / 45) : 1

      const treeActive = this.getTreeActive as TreeNode | null
      if (treeActive) {
        this.loc_active = [treeActive]
        this.loc_opened = this.$merge([], this.getTreeOpened)

        console.log('DEVICE_REPLACE_CHOOSE SETUP', 'loc_active', this.loc_active)
        console.log('DEVICE_REPLACE_CHOOSE SETUP', 'loc_opened', this.loc_opened)
        
        if (treeActive.cls === 'cabinet') {
          const store = this.$store.state as any
          this.current.cabinet = this.$merge({}, store.devices.treeActive[0])
        }
      }
    },

    getTreenodeIconColor(id: string): string {
      const store = this.$store.state as any
      const statuses = store.books.statuses
      if (statuses.length) {
        const status = store.monitoring.status[id]
        let color = statuses.find((item: any) => item.name === status)
        if (!color) {
          color = store.books.statuses.find((item: any) => item.name === 'unknown')
        }
        return color ? color.back_color : 'grey'
      }
      return 'grey'
    },

    getStyleOfUnitBySize(item: { width: number; height: number; x: number; y: number }): { width: string; height: string; top: string; left: string } {
      const [w, h, x, y] = [item.width, item.height, item.x, item.y].map(e => e * this.deviceScale)
      return {
        width: `${w}px`,
        height: `${h}px`,
        top: `${y}px`,
        left: `${x}px`
      }
    },

    itemNameDependOnSize(item: { orientation: number; height: number; width: number; name: string }): string {
      const s = item.orientation === 1 ? item.height : item.width
      return s < 30 ? '' : item.name
    },

    checkAndSelectSlot(item: any): void {
      const selectedItem = this.getSelectedItem
      if (!item.compatible.includes(selectedItem.template)) {
        this.$dialog.notify.error('Этот слот не совместим с текущим модулем', { timeout: 2000 })
      } else if (item.children.length) {
        return
      } else if (this.selectedItem === item.$id) {
        return
      } else {
        this.selectedItem = item.$id
      }
    },

    selectUnits(item: UnitItem): void {
      const deviceSize = this.deviceSize
      const activeDevice = this.getActive

      if (Number(item.position) < deviceSize) {
        this.$dialog.notify.error('В этих юнитах разместить устройство нельзя', { timeout: 5000 })
        return
      }

      const ok = this.checkSize(item)
      console.log(this.$options.name, 'selectUnits', 'ок', ok)
      if (!ok) {
        this.$dialog.notify.error('В этих юнитах разместить устройство нельзя', { timeout: 5000 })
        this.selectedSlots = []
        return
      }

      this.selectedSlots = range(deviceSize).reduce((acc, i) => acc.concat(Number(item.position) - i), [])
      this.selectedSlotsSide = item.side
      this.selectedSlot = item
    },

    checkSize(val: UnitItem): boolean {
      const position = Number(val.position)
      const closed = val.closed.filter(unit => {
        return !unit.device.some(device => device.$id === this.getActive?.$id)
      })
      const size = Math.ceil((this.getActive?.height || 0) / 45)

      this.accept.status = true
      this.accept.message = 'Ok'

      if (val.width! > 490) {
        this.accept.status = false
        this.accept.message = 'Устройство не предназначено для установки в шкаф'
        this.$snotify.warning(`Внимание! Устройство ${this.getActive?.id} не предназначено для установки в шкаф!`, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        })
        this.$emit('select')
        return false
      }

      if (position - size < 0) {
        this.accept.status = false
        this.accept.message = 'Размеры устройства превышают размеры доступного пространства'
        this.$snotify.warning(`Внимание! Размеры ${this.getActive?.id} превышают размеры доступного пространства!`, {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        })
        this.$emit('select')
        return false
      }

      for (let i = position; i > position - size; i--) {
        if (closed.some(unit => unit.position === i)) {
          if (closed.some(unit => unit.position === i && unit.device[0]?.mount === val.side)) {
            this.accept.status = false
            this.accept.message = 'Размеры устройства превышают размеры доступного пространства'
            this.$snotify.warning(`Внимание! Размеры ${this.getActive?.id} превышают размеры доступного пространства!`, {
              timeout: 2000,
              showProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
            })
            this.$emit('select')
            return false
          }

          const newDevicePositions: number[] = []
          for (let i = position; i > position - size; i--) {
            newDevicePositions.push(i)
          }

          const cabinetDepth = val.cabinet.obj.depth || 0
          const newDeviceDepth = this.getActive?.depth || 0
          let currentDepth = 0

          closed.forEach(unit => {
            if (newDevicePositions.includes(unit.position) && unit.device[0]?.depth > currentDepth) {
              currentDepth = unit.device[0].depth
            }
          })

          if (currentDepth + newDeviceDepth <= cabinetDepth) {
            console.log(this.$options.name, 'checkSize', 'OK', cabinetDepth - newDeviceDepth - currentDepth)
            return true
          }

          this.accept.status = false
          this.accept.message = 'Размеры устройства превышают размеры доступного пространства'
          this.$snotify.warning(`Внимание! Размеры ${this.getActive?.id} превышают размеры доступного пространства!`, {
            timeout: 2000,
            showProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
          })
          this.$emit('select')
          return false
        }
      }

      return true
    },

    async moveToSlot(): Promise<void> {
      try {
        const newSlot = await this.$bridge.getObjectById(this.selectedItem)
        const moved = await this.getSelectedItem.move(newSlot)

        if (moved) {
          this.$emit('load-devices')
          const query = {
            id: [this.getActive?.$id],
            notNull: true,
            data: { links: { flatten: false } }
          }
          const dev$ = await this.$bridge.cmdbQuery(query)
          await this.$store.dispatch('activeDevice', dev$[0])
          this.$dialog.notify.success('Модуль перемещен в указанный слот', { timeout: 5000 })
        } else {
          this.$dialog.notify.error(`Ошибка при перемещении в слот: ${moved}`, { timeout: 5000 })
        }
      } catch (err) {
        console.error('CATCH', this.$options.name, 'moveToSlot', err)
      }
    },

    async loadChildren(item: TreeNode): Promise<void> {
      try {
        await this.$store.dispatch('loadChildren', item)
      } catch (err) {
        console.error('CATCH', this.$options.name, 'loadChildren', err)
      }
    },

    async loadDevices(cabinet: CabinetItem): Promise<void> {
      console.log(this.$options.name, 'loadDevices', 'this.step', this.step)

      try {
        const devices = await cabinet.getLinks() as DeviceItem[]
        this.$set(this.current.cabinet, 'children', devices)

        const closedSet = new Set<number>()
        devices.forEach(d => {
          if (d.height && d.position) {
            const count = Math.ceil(d.height / 45)
            for (let i = 0; i < count; i++) {
              closedSet.add(d.position! - i)
            }
          }
        })

        const all = range(cabinet.usize || 0)
        this.slots = all.map(a => ({ opened: !closedSet.has(a + 1), name: a + 1 }))
        this.step = 1
      } catch (err) {
        console.error('CATCH', this.$options.name, 'loadDevices', err)
      }
    },

    reset(): void {
      this.selectedSlot = null
      this.selectedSlots = []
      this.selectedSlotsSide = 'front'
      this.loc_select = true
      this.step = 0
      this.deviceSize = 1
      this.deviceSide = 'front'
      this.selected = ''
      this.selectedItem = ''
      this.slots = []
      this.current = { cabinet: {} }
      this.accept = { status: true, message: 'Ok' }
    },

    close(): void {
      this.reset()
      this.$emit('close')
    },

    async chooseUnit(): Promise<void> {
      try {
        const cabinet = this.loc_select ? this.loc_active[0] : this.getTreeActive
        this.current.cabinet = this.$merge({}, cabinet)
        console.log(this.$options.name, 'chooseUnit', 'cabinet', cabinet)
        console.log(this.$options.name, 'chooseUnit', 'step', this.step)

        if (this.step === 0) {
          await this.loadDevices(cabinet as CabinetItem)
        } else {
          const $device = await this.$bridge.getObjectById(this.$store.state.devices.activeDevice.$id)

          if (this.loc_active.length && this.loc_active[0]?.cls === 'cabinet') {
            const moved = await $device.move(this.loc_active[0])
            if (moved) {
              this.$dialog.notify.success('Устройство перемещено в указанную стойку', { timeout: 5000 })
              this.setup()
            } else {
              this.$dialog.notify.error(`Ошибка при перемещении в стойку: ${moved}`, { timeout: 5000 })
            }
          } else if (this.getTreeActive?.$id !== cabinet?.$id) {
            await $device.move(cabinet)
          }

          const upd = await $device.update({
            position: this.selectedSlots[0],
            mount: this.selectedSlotsSide
          })

          if (upd) {
            this.$emit('load-devices')
            this.$dialog.notify.success('Устройство размещено в стойке в указанной позиции', { timeout: 5000 })
            this.setup()
          } else {
            this.$dialog.notify.error(`Ошибка при обновлении позиции: ${upd}`, { timeout: 5000 })
          }
        }
      } catch (err) {
        console.error('CATCH', this.$options.name, 'chooseUnit', err)
      }
    },

    async moveToLocation(): Promise<void> {
      const treeActive = this.getTreeActive
      if (treeActive?.$id === this.loc_active[0]?.$id) {
        this.$dialog.notify.error('Устройство уже находится в выбранной локации', { timeout: 5000 })
        return
      }

      try {
        const $device = await this.$bridge.getObjectById(this.$store.state.devices.activeDevice.$id)
        const parent = await $device.getParent()
        const moved = await $device.move(this.loc_active[0])

        if (moved) {
          this.$emit('load-devices')
          this.$dialog.notify.success('Устройство перемещено в указанную локацию', { timeout: 5000 })
          if (parent && parent.cls === 'folder') {
            this.$store.dispatch('loadTree')
          }
          this.setup()
        } else {
          this.$dialog.notify.error(`Ошибка при перемещении в локацию: ${moved}`, { timeout: 5000 })
        }
      } catch (err) {
        console.error('CATCH', this.$options.name, 'moveToLocation', err)
      }
    },

    async moveToRoot(): Promise<void> {
      try {
        const $device = await this.$bridge.getObjectById(this.$store.state.devices.activeDevice.$id)
        const root = this.$store.getters.getRootElement

        if (root) {
          const moved = await $device.move(root)

          if (moved) {
            if (moved.cls === 'device' || moved.cls === 'module') {
              const data$ = { tree_view: 'true' }
              await moved.update(data$)
            }
            this.$emit('load-devices')
            this.$dialog.notify.success('Устройство установлено корневым элементом', { timeout: 5000 })
            this.$store.dispatch('loadTree')
            this.setup()
          } else {
            this.$dialog.notify.error('Ошибка при установке корневым элементом', { timeout: 5000 })
          }
        }
      } catch (err) {
        console.error('CATCH', this.$options.name, 'moveToRoot', err)
      }
    },
  },
})
</script>

<style lang="stylus" scoped>

.treeLeaf
  border-radius 4px
  border solid 1px rgb(228, 226, 226)
  height 48px

.selected-item
  background-color lightblue
.closed
  background-color grey

.fade-enter-active
.fade-leave-active
  transition opacity .2s
.fade-enter
.fade-leave-to
  opacity 0

.v-list.slots a.v-list__tile
  height 20px
  font-size 8pt
  width fit-content
  margin auto
  .v-list__tile__title
    line-height 20px
// выбор слота в девайсе
.choosing-slot
  margin-left 20px
  .device
    display flex
    margin 20px 0
    outline 2px solid dimgray
    flex-wrap wrap
    align-content center
    justify-content center
    position relative
    .device-item
      //flex-basis 25px
      cursor pointer
      outline 1px solid darkgrey
      display flex
      justify-content center
      align-items center
      position absolute
      &.compatible
        background-color palegreen
      &.buzy_slot
        background-color lightgray
      &.current
        background-color lightcoral
      &.selected
        background-color  lightblue
      .slot-name
        font-size 8pt
        &.vertical
          transform rotate(270deg)

</style>
